import types from './types';
import AuthDialogConstants from '../../components/dialogs/AuthDialog/AuthDialogConstants';
import ColoredSnackbarConstants from '../../components/misc/ColoredSnackbar/ColoredSnackbarConstants';
import { createObjectCopy } from '../../utilities/objectUtilities';
import AppConstants from '../AppConstants';
import update from '../../utilities/updateStateUtilities';
import { getRecommendedCurrency } from '../../utilities/userUtilities';

const INITIAL_STATE = {
    snackOpen: false,
    snackMessage: '',
    snackVariant: ColoredSnackbarConstants.SNACKBAR_INFO,
    errorOpen:false,
    errorMessage: '',
    loggedIn: false,
    authDialogOpen: false,
    tunebatIntegrationDialogOpen: false,
    authDialogFormType: AuthDialogConstants.FORM_TYPE_SIGN_UP,
    authDialogRequesting: false,
    refreshMethod: null,
    accountDetails: createObjectCopy(AppConstants.DEFAULT_ACCOUNT_DETAILS),
    gettingAccountDetails: false,
    purchaseOptions: [],
    loadingPurchaseOptions: false,
    recommendedCurrency: getRecommendedCurrency(),
    informationDialogOpen: false,
    informationDialogTitle: '',
    informationDialogText: ''
}

const appReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case types.SET_PROPERTY: {
            return update.set(state, action.key, action.value);
        }
        case types.OPEN_SNACK: {
            return {
                ...state,
                snackOpen: true,
                snackMessage: action.text,
                snackVariant: action.variant
            };
        }
        case types.CLOSE_SNACK: {
            return {
                ...state,
                snackOpen: false,
            };
        }

        case types.OPEN_AUTH_DIALOG: {
            return {
                ...state,
                authDialogOpen: true,
                authDialogFormType: action.formType ? action.formType : state.authDialogFormType
            };
        }
        case types.CLOSE_AUTH_DIALOG: {
            return {
                ...state,
                authDialogOpen: false,
                refreshMethod: null
            };
        }
        case types.SET_AUTH_DIALOG_FORM_TYPE: {
            return {
                ...state,
                authDialogFormType: action.formType
            };
        }
        case types.START_AUTH_DIALOG_REQUEST: {
            return {
                ...state,
                authDialogRequesting: true
            };
        }
        case types.STOP_AUTH_DIALOG_REQUEST: {
            return {
                ...state,
                authDialogRequesting: false
            };
        }
        case types.COMPLETE_LOGIN: {
            if (action.success) {
                
                return {
                    ...state,
                    authDialogRequesting: false,
                    authDialogOpen: false,
                    loggedIn: true,
                    refreshMethod: null,
                    snackOpen: true,
                    snackMessage: 'You are logged in!',
                    snackVariant: ColoredSnackbarConstants.SNACKBAR_SUCCESS
                };
            } else {
                return {
                    ...state,
                    authDialogFormType: AuthDialogConstants.FORM_TYPE_LOGIN,
                    authDialogRequesting: false,
                    authDialogOpen: true,
                    loggedIn: false,
                    snackOpen: true,
                    snackMessage: action.message,
                    snackVariant: ColoredSnackbarConstants.SNACKBAR_ERROR
                };
            }
        }
        case types.COMPLETE_SIGN_UP: {
            if (action.success) {

                return {
                    ...state,
                    authDialogRequesting: false,
                    authDialogOpen: false,
                    loggedIn: true,
                    refreshMethod: null,
                    snackOpen: true,
                    snackMessage: 'Account created! You are logged in.',
                    snackVariant: ColoredSnackbarConstants.SNACKBAR_SUCCESS
                };
            } else {
                return {
                    ...state,
                    authDialogFormType: AuthDialogConstants.FORM_TYPE_SIGN_UP,
                    authDialogRequesting: false,
                    authDialogOpen: true,
                    loggedIn: false,
                    snackOpen: true,
                    snackMessage: action.message,
                    snackVariant: ColoredSnackbarConstants.SNACKBAR_ERROR
                };
            }
        }
        case types.COMPLETE_PASSWORD_RECOVER_REQUEST: {
            if (action.success) {
                return {
                    ...state,
                    authDialogRequesting: false,
                    snackOpen: true,
                    snackMessage: 'A reset link was sent to your email.',
                    snackVariant: ColoredSnackbarConstants.SNACKBAR_SUCCESS
                };
            } else {
                return {
                    ...state,
                    authDialogFormType: AuthDialogConstants.FORM_TYPE_RESET,
                    authDialogRequesting: false,
                    authDialogOpen: true,
                    snackOpen: true,
                    snackMessage: action.message,
                    snackVariant: ColoredSnackbarConstants.SNACKBAR_ERROR
                };
            }
        }

        case types.SET_REFRESH_METHOD: {
            return {
                ...state,
                refreshMethod: action.refreshMethod
            }
        }

        case types.SET_ACCOUNT_DETAILS: {
            return {
                ...state,
                accountDetails: action.details
            }
        }
        case types.SET_GETTING_ACCOUNT_DETAILS: {
            return {
                ...state,
                gettingAccountDetails: action.isGetting
            }
        }
        case types.SHOW_INFORMATION_DIALOG: {
            return {
                ...state,
                informationDialogOpen: action.open,
                informationDialogTitle: action.title,
                informationDialogText: action.text,
                informationDialogButtonText: action.buttonText
            }
        }

        default: return state;
    }
}

export default appReducer;